import { render, staticRenderFns } from "./StoryblokWebsiteBanner.vue?vue&type=template&id=47cb4393&"
import script from "./StoryblokWebsiteBanner.vue?vue&type=script&lang=ts&"
export * from "./StoryblokWebsiteBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports